import { Component, Input } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Breadcrumb } from '../../../../models/shared/stylesheet/breadcrumb';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: true,
  imports: [NgFor, NgClass, NgIf, RouterLink]
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs!: Breadcrumb[];
}
